export default __webpack_public_path__ + "static/media/contact_mail.768fb0d1.svg";